<div style="margin-top: 24px">
  @if (selectedCrafts().length === 0) {
    <p>No crafts selected! Make sure you mark the wanted crafts in the Setup Page!</p>
  }

  <!-- MARK: Totals -->
  @if (selectedCrafts().length > 0) {
    <mat-card style="margin-bottom: 24px">
      <mat-card-content style="padding: 16px">
        <div style="display: flex; align-items: center; gap: 16px; margin-bottom: 16px">
          <mat-icon>assessment</mat-icon>
          <h2 style="margin: 0; font-weight: 500">Total Summary ({{ selectedCrafts().length }} craft{{ selectedCrafts().length === 1 ? '' : 's' }})</h2>
        </div>

        <!-- Totals Info Grid -->
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); gap: 16px; margin-bottom: 16px">
          <div>
            <div style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Total Income</div>
            <span style="font-size: 1.25rem; font-weight: 500">{{ this.craftCalculatorStateService.craftGroup().totalIncome() | number: '1.0-0' }}</span>
          </div>

          <div>
            <div style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Total Expenses</div>
            <span style="font-size: 1.25rem; font-weight: 500">{{ this.craftCalculatorStateService.craftGroup().totalExpenses() | number: '1.0-0' }}</span>
          </div>

          <div>
            <div style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Total Input Weight</div>
            <span style="font-size: 1.25rem; font-weight: 500">{{ this.craftCalculatorStateService.craftGroup().totalInputWeight() | number: '1.0-0' }} kg</span>
          </div>

          <div>
            <div style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Total Output Weight</div>
            <span style="font-size: 1.25rem; font-weight: 500">{{ this.craftCalculatorStateService.craftGroup().totalOutputWeight() | number: '1.0-0' }} kg</span>
          </div>

          <div>
            <div style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Total Fame</div>
            <span style="font-size: 1.25rem; font-weight: 500">{{ this.craftCalculatorStateService.craftGroup().totalCraftFamePlayerTotal() | number: '1.0-0' }}</span>
          </div>

          @if (this.craftCalculatorStateService.craftGroup().totalFocus()) {
            <div>
              <div style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Total Focus</div>
              <span style="font-size: 1.25rem; font-weight: 500">{{ this.craftCalculatorStateService.craftGroup().totalFocus() | number: '1.0-0' }}</span>
            </div>

            <div>
              <div style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Avg Profit Per Focus</div>
              <span style="font-size: 1.25rem; font-weight: 500">{{ this.craftCalculatorStateService.craftGroup().totalResult() / this.craftCalculatorStateService.craftGroup().totalFocus() | number: '1.0-0' }}</span>
            </div>
          }

          <div>
            <div style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Total Craft Fee</div>
            <span style="font-size: 1.25rem; font-weight: 500">{{ this.craftCalculatorStateService.craftGroup().totalCraftFee() | number: '1.0-0' }}</span>
          </div>

          <div style="grid-column: span 2; min-width: 200px">
            <div style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Total Profit</div>
            <span style="font-size: 1.5rem; font-weight: 700" [style.color]="this.craftCalculatorStateService.craftGroup().totalResult() >= 0 ? 'var(--profit-color)' : 'var(--loss-color)'">
              {{ this.craftCalculatorStateService.craftGroup().totalResult() | number: '1.0-0' }}
              @if (this.craftCalculatorStateService.craftGroup().totalExpenses() > 0) {
                ({{ this.craftCalculatorStateService.craftGroup().totalResult() / this.craftCalculatorStateService.craftGroup().totalExpenses() | percent: '1.2-2' }})
              }
            </span>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  }

  <!-- MARK: Crafts -->
  @for (craft of selectedCrafts(); track craft.product.uniqueName; let i = $index) {
    <mat-card style="margin-bottom: 16px">
      <mat-card-content style="padding: 16px">
        <div style="display: flex; align-items: center; gap: 16px">
          <!-- Step Number -->
          <mat-chip-set>
            <mat-chip color="primary" selected>{{ i + 1 }}</mat-chip>
          </mat-chip-set>

          <!-- Item Image -->
          <div style="flex-shrink: 0">
            <app-item-image [item]="craft.product" [size]="50" />
          </div>

          <!-- Item Details -->
          <div style="flex: 1; min-width: 0">
            <h3 style="margin: 0 0 16px 0; font-weight: 500">
              {{ craft.product.localizedName }}
            </h3>

            <!-- Results Info Grid -->
            <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 16px; margin-bottom: 16px">
              <div>
                <div style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Total Income</div>
                <span style="font-size: 1.125rem; font-weight: 500">{{ craft.totalIncome() | number: '1.0-0' }}</span>
              </div>

              <div>
                <div style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Total Expenses</div>
                <span style="font-size: 1.125rem; font-weight: 500">{{ craft.totalExpenses() | number: '1.0-0' }}</span>
              </div>

              <div>
                <div style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Input Weight</div>
                <span style="font-size: 1.125rem; font-weight: 500">{{ craft.totalInputsWeight() | number: '1.0-0' }} kg</span>
              </div>

              <div>
                <div style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Output Weight</div>
                <span style="font-size: 1.125rem; font-weight: 500">{{ craft.totalOutputsWeight() | number: '1.0-0' }} kg</span>
              </div>

              <div>
                <div style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Total Fame</div>
                <span style="font-size: 1.125rem; font-weight: 500">{{ craft.craftFamePlayerTotal() | number: '1.0-0' }}</span>
              </div>

              @if (craft.totalFocus()) {
                <div>
                  <div style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Total Focus</div>
                  <span style="font-size: 1.125rem; font-weight: 500">{{ craft.totalFocus() | number: '1.0-0' }}</span>
                </div>

                <div>
                  <div style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Profit Per Focus</div>
                  <span style="font-size: 1.125rem; font-weight: 500">{{ craft.resultPerFocus() | number: '1.0-0' }}</span>
                </div>
              }

              <div>
                <div style="display: block; margin-bottom: 4px; font-size: 0.875rem; opacity: 0.7">Profit</div>
                <span style="font-size: 1.125rem; font-weight: 500" [style.color]="craft.result() >= 0 ? 'var(--profit-color)' : 'var(--loss-color)'">
                  {{ craft.result() | number: '1.0-0' }} ({{ craft.resultPercent() | percent: '1.2-2' }})
                </span>
              </div>
            </div>

            <!-- Craft Inputs Section -->
            @if (craft.craftInputs().length > 0) {
              <div style="margin-bottom: 16px">
                <h4 style="margin: 0 0 12px 0; font-weight: 500">Inputs</h4>
                <div style="display: grid; gap: 8px">
                  @for (craftInput of craft.craftInputs(); track craftInput.inputItem.item.uniqueName) {
                    <div style="display: flex; align-items: center; gap: 12px; padding: 8px; background: rgba(0, 0, 0, 0.05); border-radius: 8px">
                      <!-- Input Item Image -->
                      <app-item-image [item]="craftInput.inputItem.item" [size]="32" />

                      <!-- Input Details -->
                      <div style="flex: 1; min-width: 0">
                        <div style="font-weight: 500; margin-bottom: 2px">{{ craftInput.inputItem.item.localizedName }}</div>
                        <div style="font-size: 0.875rem; opacity: 0.7">
                          Amount: {{ craftInput.amount().amountUsed | number: '1.0-0' }}
                          @if (craftInput.amount().leftOverAmount > 0) {
                            ({{ craftInput.amount().leftOverAmount | number: '1.0-0' }} leftover)
                          }
                        </div>
                        <div style="font-size: 0.875rem; opacity: 0.7">Bought in {{ craftInput.inputItem.buyLocation()?.displayName ?? 'unset' }}</div>
                      </div>

                      <!-- Purchase Cost Details -->
                      <div style="text-align: right; flex-shrink: 0; min-width: 120px">
                        <div style="font-weight: 500; margin-bottom: 2px">Purchase Cost</div>
                        <div style="font-size: 0.875rem">{{ craftInput.buyCostWithoutFee() | number: '1.0-0' }}</div>
                        <div style="font-size: 0.75rem; opacity: 0.7">{{ craftInput.inputItem.buyUserPrice() | number: '1.0-0' }}/unit</div>
                        @if (craftInput.buySetupFeeCost() > 0) {
                          <div style="font-size: 0.75rem">+{{ craftInput.buySetupFeeCost() | number: '1.0-0' }} setup fee</div>
                        }
                      </div>

                      <!-- Leftover Income Details (only if there are leftovers) -->
                      @if (craftInput.amount().leftOverAmount > 0) {
                        <div style="text-align: right; flex-shrink: 0; min-width: 120px; border-left: 1px solid rgba(0, 0, 0, 0.1); padding-left: 12px">
                          <div style="font-weight: 500; margin-bottom: 2px">Leftover Income</div>
                          <div style="font-size: 0.875rem">{{ craftInput.sellIncomeWithoutFeeOrTax() | number: '1.0-0' }}</div>
                          <div style="font-size: 0.75rem; opacity: 0.7">{{ craftInput.inputItem.sellUserPrice() | number: '1.0-0' }}/unit</div>
                          @if (craftInput.sellSetupFeeCost() > 0) {
                            <div style="font-size: 0.75rem">-{{ craftInput.sellSetupFeeCost() | number: '1.0-0' }} setup fee</div>
                          }
                          @if (craftInput.sellTaxesCost() > 0) {
                            <div style="font-size: 0.75rem">-{{ craftInput.sellTaxesCost() | number: '1.0-0' }} sales tax</div>
                          }
                        </div>
                      }

                      <!-- Net Cost -->
                      <div style="text-align: right; flex-shrink: 0; min-width: 80px; border-left: 1px solid rgba(0, 0, 0, 0.1); padding-left: 12px">
                        <div style="font-weight: 500; margin-bottom: 2px">Net Cost</div>
                        <div style="font-size: 1rem; font-weight: 500">{{ craftInput.buyCostWithFee() - craftInput.sellIncomeWithFeeAndTax() | number: '1.0-0' }}</div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }

            <!-- Craft Outputs Section -->
            @if (craft.craftOutputs.length > 0) {
              <div style="margin-bottom: 16px">
                <h4 style="margin: 0 0 12px 0; font-weight: 500">Outputs</h4>
                <div style="display: grid; gap: 8px">
                  @for (craftOutput of craft.craftOutputs; track craftOutput.outputItem.item.uniqueName) {
                    <div style="display: flex; align-items: center; gap: 12px; padding: 8px; background: rgba(0, 0, 0, 0.05); border-radius: 8px">
                      <!-- Output Item Image -->
                      <app-item-image [item]="craftOutput.outputItem.item" [size]="32" />

                      <!-- Output Details -->
                      <div style="flex: 1; min-width: 0">
                        <div style="font-weight: 500; margin-bottom: 2px">{{ craftOutput.outputItem.item.localizedName }}</div>
                        <div style="font-size: 0.875rem; opacity: 0.7">Amount: {{ craftOutput.amount() | number: '1.0-0' }}</div>
                        <div style="font-size: 0.875rem; opacity: 0.7">Sold in {{ craftOutput.outputItem.sellLocation()?.displayName ?? 'unset' }}</div>
                      </div>

                      <!-- Gross Income Details -->
                      <div style="text-align: right; flex-shrink: 0; min-width: 120px">
                        <div style="font-weight: 500; margin-bottom: 2px">Gross Income</div>
                        <div style="font-size: 0.875rem">{{ craftOutput.sellIncomeWithoutFeeOrTax() | number: '1.0-0' }}</div>
                        <div style="font-size: 0.75rem; opacity: 0.7">{{ craftOutput.outputItem.sellUserPrice() | number: '1.0-0' }}/unit</div>
                      </div>

                      <!-- Fees and Taxes -->
                      <div style="text-align: right; flex-shrink: 0; min-width: 100px">
                        <div style="font-weight: 500; margin-bottom: 2px">Deductions</div>
                        @if (craftOutput.setupFeeCost() > 0) {
                          <div style="font-size: 0.75rem">-{{ craftOutput.setupFeeCost() | number: '1.0-0' }} setup fee</div>
                        }
                        @if (craftOutput.salesTaxCost() > 0) {
                          <div style="font-size: 0.75rem">-{{ craftOutput.salesTaxCost() | number: '1.0-0' }} sales tax</div>
                        }
                        @if (craftOutput.setupFeeCost() === 0 && craftOutput.salesTaxCost() === 0) {
                          <div style="font-size: 0.75rem; opacity: 0.5">No fees</div>
                        }
                      </div>

                      <!-- Net Income -->
                      <div style="text-align: right; flex-shrink: 0; min-width: 80px; border-left: 1px solid rgba(0, 0, 0, 0.1); padding-left: 12px">
                        <div style="font-weight: 500; margin-bottom: 2px">Net Income</div>
                        <div style="font-size: 1rem; font-weight: 500">{{ craftOutput.sellIncomeWithFeeAndTax() | number: '1.0-0' }}</div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }

            <!-- Additional Costs -->
            @if (craft.totalCraftFee() > 0 || craft.totalFixedCost() > 0 || craft.extraExpenses() > 0) {
              <div style="margin-bottom: 16px">
                <h4 style="margin: 0 0 12px 0; font-weight: 500">Additional Costs</h4>
                <div style="display: grid; gap: 8px">
                  @if (craft.totalCraftFee() > 0) {
                    <div style="display: flex; justify-content: space-between; align-items: center; padding: 4px 8px; background: rgba(0, 0, 0, 0.05); border-radius: 4px">
                      <div>
                        <div style="font-weight: 500; margin-bottom: 2px">Crafting Fee</div>
                        <div style="font-size: 0.875rem; opacity: 0.7">{{ craft.craftFeePerNutrition() | number: '1.0-0' }}/nutrition</div>
                        <div style="font-size: 0.875rem; opacity: 0.7">Crafted in {{ craft.craftLocation()?.displayName ?? 'unset' }}</div>
                      </div>
                      <span>{{ craft.totalCraftFee() | number: '1.0-0' }}</span>
                    </div>
                  }
                  @if (craft.totalFixedCost() > 0) {
                    <div style="display: flex; justify-content: space-between; padding: 4px 8px; background: rgba(0, 0, 0, 0.05); border-radius: 4px">
                      <span>Fixed Cost (Silver)</span>
                      <span>{{ craft.totalFixedCost() | number: '1.0-0' }}</span>
                    </div>
                  }
                  @if (craft.extraExpenses() > 0) {
                    <div style="display: flex; justify-content: space-between; padding: 4px 8px; background: rgba(0, 0, 0, 0.05); border-radius: 4px">
                      <span>Extra Expenses</span>
                      <span>{{ craft.extraExpenses() | number: '1.0-0' }}</span>
                    </div>
                  }
                </div>
              </div>
            }

            <!-- Action Buttons -->
            <div style="display: flex; gap: 8px; align-items: center; flex-wrap: wrap">
              <app-copy-text-button [text]="craft.product.localizedName"></app-copy-text-button>
              <app-check-price-button [itemUniqueName]="craft.product.uniqueName"></app-check-price-button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  }
</div>
